








































































































































































import {
  CartGoods,
  CartModel,
  cartModelProvider,
  getCartModel,
} from '@/views/cart/model'
import { defineClassComponent, useLoaded, useNewRoute } from '@/hooks'
import { navigateTo } from '@/router'
import {
  nextTick,
  onActivated,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from '@vue/composition-api'
import { submit, Track } from '@/utils'

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: 'TV-购物车',
        }))

        useLoaded(this.loading, () => ctx.$tv.goTo(ctx.$refs.checkout))

        // 提供购物车数据
        cartModelProvider.provide(this.cartModel as any)

        useNewRoute(this.showEditDialog)

        watch(
          () => this.showEditDialog.value,
          () => {
            if (this.showEditDialog.value) {
              nextTick(() => {
                ctx.$tv.setLimitingEl((ctx.$refs.editDialog as any).$el)
                ctx.$tv.goTo((ctx.$refs.stepper as any).$el)
              })
            } else {
              nextTick(() => {
                ctx.$tv.resetLimitingEl()
              })
            }
          },
        )

        onMounted(async () => {
          // 获取购物车数据
          this.cartModel.value = (await getCartModel()) as any
          this.loading.value = false
        })

        onActivated(() => {
          // 刷新购物车数据
          this.cartModel.value.refresh?.()
        })

        onBeforeUnmount(() => {
          // 释放购物车数据
          this.cartModel.value.$destroy?.()
        })
      }

      // 是否加载中
      loading = ref(true)

      // 购物车数据
      cartModel = ref<CartModel>({} as any)

      // 编辑中的商品
      editGoods = ref<CartGoods>()

      // 新的购买数量
      newBuyCount = ref(0)

      // 是否显示编辑弹窗
      showEditDialog = ref(false)

      // 点击进店
      handleEnterStoreClick = (id: string) => {
        navigateTo('TvMartIndex', { id })
      }

      // 点击详情
      handleDetailClick = (goodsId: string) => {
        navigateTo('TvGoodsIndex', {
          id: goodsId,
        })
      }

      // 点击修改
      handleEditClick = (goods: CartGoods) => {
        this.editGoods.value = goods
        this.newBuyCount.value = goods.buyCount
        this.showEditDialog.value = true
      }

      // 点击删除
      handleDeleteClick = (skuId: string) => {
        submit(async $ => {
          $.start()
          await this.cartModel.value.delete([skuId], true)
          await $.success('删除成功')
        })
      }

      // 点击去结算
      handleCheckoutClick = () => {
        this.cartModel.value.checkout()
      }

      // 编辑确认
      handleEditConfirm = () => {
        this.editGoods.value!.buyCount = this.newBuyCount.value
        this.showEditDialog.value = false
      }
    },
)
